import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { Subscription } from "rxjs";
import { ApiService } from "../../../providers/api.service";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { MatDialog } from "@angular/material/dialog";
import { AddNewBookingComponent } from "src/app/shared/components/add-new-booking/add-new-booking.component";
import { ManageBookingComponent } from "src/app/shared/components/manage-booking/manage-booking.component";
import { AssignJobComponent } from "src/app/shared/components/assign-job/assign-job.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { CustomiseBookingComponent } from "src/app/shared/components/customise-booking/customise-booking.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { AddEditTaxGstComponent } from "src/app/shared/components/add-edit-tax-gst/add-edit-tax-gst.component";
import { AddEditDiscountsComponent } from "src/app/shared/components/add-edit-discounts/add-edit-discounts.component";
import { AddEditOnlinePaymentComponent } from "src/app/shared/components/add-edit-online-payment/add-edit-online-payment.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { AddExistingAccountComponent } from "src/app/shared/components/add-existing-account/add-existing-account.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { LinkInternationalOnlinePaymentDetailsComponent } from "../../new-v2-pages/new-v2-component/link-international-online-payment-details/link-international-online-payment-details.component";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "sm-online-payments",
  templateUrl: "./online-payments.component.html",
  styleUrls: ["./online-payments.component.scss"],
})
export class OnlinePaymentsComponent implements OnInit, OnDestroy {
  isEntityForeign: any;
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  entityHashId: string = "";
  onlinePaymentsData: any = [];
  internationalOnlinePaymentsData: any = [];
  bankDetailsData: any = [];
  internationalBankDetailsData: any = [];
  toShowCheck: number = 1;
  toShowCheckForInternational: number = 1;
  private _apiSubscription: Subscription;
  loader: boolean = false;
  constructor(
    private _navService: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    public _modelRef: MatDialog,
    private loaderService: LoaderServiceService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private snackbar: MatSnackBar
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.GET_BANK_INFO_RESULT) {
        this.onlinePaymentsData = [];
        this.internationalOnlinePaymentsData = [];
        this.bankDetailsData = [];
        this.internationalBankDetailsData = [];
        if (resData.result) {
          if (
            resData.result.data.all_bank_accounts &&
            resData.result.data.all_bank_accounts?.length > 0
          ) {
            this.bankDetailsData = resData.result.data.all_bank_accounts;
          }

          if (resData.result.data.business_bank_details) {
            if (resData.result.data.business_bank_details) {
              this.onlinePaymentsData.push(
                resData.result.data.business_bank_details
              );
              console.log("onlinepayments", this.onlinePaymentsData);

              this.toShowCheck =
                this.onlinePaymentsData[0].online_payment_status;
              this.onlinePaymentsData[0].account_type = parseInt(
                this.onlinePaymentsData[0].account_type
              );
            }
            // resData.result.forEach((element:any) => {
            // });
          } else {
            this.toShowCheck = 0;
          }
        }
        console.log("bank", this.bankDetailsData);

        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_DOMESTIC_ENTITY_BANK_INFO
      ) {
        this.onlinePaymentsData = [];
        this.internationalOnlinePaymentsData = [];
        this.bankDetailsData = [];
        this.internationalBankDetailsData = [];
        if (resData.result) {
          if (
            resData.result.data.all_bank_accounts &&
            resData.result.data.all_bank_accounts?.length > 0
          ) {
            this.bankDetailsData = resData.result.data.all_bank_accounts;
          }

          if (resData.result.data.entity_bank_details) {
            if (resData.result.data.entity_bank_details) {
              this.onlinePaymentsData.push(
                resData.result.data.entity_bank_details
              );
              console.log("onlinepayments", this.onlinePaymentsData);

              this.toShowCheck =
                this.onlinePaymentsData[0].online_payment_status;
            }
            // resData.result.forEach((element:any) => {
            // });
          } else {
            this.toShowCheck = 0;
          }
        }
        console.log("bank", this.bankDetailsData);

        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_BANK_INFO
      ) {
        this.onlinePaymentsData = [];
        this.internationalOnlinePaymentsData = [];
        this.bankDetailsData = [];
        this.internationalBankDetailsData = [];
        if (resData.result) {
          if (resData.result.errorcode == 0) {
            if (
              resData.result.data.all_bank_accounts &&
              resData.result.data.all_bank_accounts?.length > 0
            ) {
              this.internationalBankDetailsData =
                resData.result.data.all_bank_accounts;
            }

            if (resData.result.data.entity_bank_details) {
              if (resData.result.data.entity_bank_details) {
                this.internationalOnlinePaymentsData.push(
                  resData.result.data.entity_bank_details
                );
                console.log(
                  "internationalonlinepayments",
                  this.internationalOnlinePaymentsData
                );

                this.toShowCheckForInternational =
                  this.internationalOnlinePaymentsData[0].online_payment_status;
              }
              // resData.result.forEach((element:any) => {
              // });
            } else {
              this.toShowCheckForInternational = 0;
            }
          } else {
            console.error(resData.result);
          }
        }
        console.log("bank", this.bankDetailsData);

        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ENABLE_ONLINE_PAYMENTS
      ) {
        if (resData.result) {
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ENABLE_INTERNATIONAL_ONLINE_PAYMENTS
      ) {
        if (resData.result) {
          this._apiService.getInternationalEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SYNC_LATEST_PAYPAL_DATA
      ) {
        if (resData.result) {
          this._apiService.getInternationalEntityBankInfo(this.entityHashId);
        }
      }
      if (resData.responseType === SM_CONSTANTS.UPDATE_BANK_INFO_RESULT) {
        if (resData.result) {
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_LINKED_BANK_ACCOUNT
      ) {
        if (resData.result) {
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UNLINK_BANK_ACCOUNT_FROM_BUSINESS
      ) {
        if (resData.result) {
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UNLINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT
      ) {
        if (resData.result) {
          this._apiService.getInternationalEntityBankInfo(this.entityHashId);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CREATE_PAYPAL_PARTNER_ACCOUNT
      ) {
        if (resData.result) {
          if (resData.result?.email_verification_status == 0) {
            this.loaderService.showLoader = false;
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "600px",
                data: {
                  title: " Error!",
                  message:
                    "Your E-mail id is not verified. Go to profile and check email for once. Verify it with the verification link. Once done, come here again and retry.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              }
            );
          } else {
            if (resData.result.data.redirect_urls[1].href) {
              this.loaderService.showLoader = false;
              window.location.href = resData.result.data.redirect_urls[1].href;

              // const width = 600;
              // const height = 700;
              // const left = (window.innerWidth - width) / 2;
              // const top = (window.innerHeight - height) / 2;

              // const popup = window.open(
              //   resData.result.data.redirect_urls[1].href, // from backend
              //   'PayPal Onboarding',
              //   `width=${width},height=${height},top=${top},left=${left}`
              // );
            }
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_PAYPAL_SELLER_ACCOUNT_DETAILS
      ) {
        if (resData.result) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              entityHash: this.entityHashId,
              isEntityForeign: this.isEntityForeign,
            },
            queryParamsHandling: "", // Clears all other params
            replaceUrl: true,
          });
          if (this.isEntityForeign == "0") {
            this._apiService.getDomesticEntityBankInfo(this.entityHashId);
          } else if (this.isEntityForeign == "1") {
            this.loaderService.showLoader = true;
            this.loader = true;
            this._apiService.getInternationalEntityBankInfo(this.entityHashId);
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CREATE_RAZORPAY_SUB_MERCHANT_ACCOUNT
      ) {
        if (resData.result) {
          if (resData.result?.errorcode == 10002) {
            this.loaderService.showLoader = false;
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "600px",
                data: {
                  title: " Error!",
                  message:
                    "Your E-mail id is not verified. Go to profile and check email for once. Verify it with the verification link. Once done, come here again and retry.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              }
            );
          } else {
            if (resData.result.data.onboarding_url) {
              this.loaderService.showLoader = false;
              window.location.href = resData.result.data.onboarding_url;

              // const width = 600;
              // const height = 700;
              // const left = (window.innerWidth - width) / 2;
              // const top = (window.innerHeight - height) / 2;

              // const popup = window.open(
              //   resData.result.data.redirect_urls[1].href, // from backend
              //   'PayPal Onboarding',
              //   `width=${width},height=${height},top=${top},left=${left}`
              // );
            }
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_RAZORPAY_SUB_MERCHANT_ACCOUNT_DETAILS
      ) {
        if (resData.result) {
          if (resData.result.errorcode == 1) {
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "400px",
                data: {
                  title: "Alert",
                  message:
                    "Some error occured while updating your Razorpay account details. Please try again later",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              }
            );
          }

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              entityHash: this.entityHashId,
              isEntityForeign: this.isEntityForeign,
            },
            queryParamsHandling: "", // Clears all other params
            replaceUrl: true,
          });
          if (this.isEntityForeign == "0") {
            this.loaderService.showLoader = true;
            this.loader = true;
            this._apiService.getDomesticEntityBankInfo(this.entityHashId);
          } else if (this.isEntityForeign == "1") {
            this.loaderService.showLoader = true;
            this.loader = true;
            this._apiService.getInternationalEntityBankInfo(this.entityHashId);
          }
        }
      }
    });
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
  }

  ngOnInit(): void {
    // this.loader = true
    this.route.queryParams.subscribe((data) => {
      if (data.merchantIdInPayPal && data.merchantId) {
        this.entityHashId = data.entityHash;
        this.isEntityForeign = data.isEntityForeign;

        let bodydata = {
          tracking_id: data.merchantId,
          entity_hash: data.entityHash,
          seller_merchant_id: data.merchantIdInPayPal,
        };
        this.loaderService.showLoader = true;
        this.loader = true;
        this._apiService.updatePaypalSellerAccountDetails(bodydata);
      } else if (data.code && data.state) {
        const parsed = this.parseRazorpayState(data.state);
        const entityHashFromState = parsed.params["entityHash"] ?? null;

        if (entityHashFromState) {
          this.entityHashId = entityHashFromState;
          this.isEntityForeign = "0";
        }

        let bodydata = {
          entity_hash: this.entityHashId,
          account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          state: parsed.stateToken || data.state,
          razorpay_auth_code: data.code,
          origin: 1,
        };
        console.log("data:::>>>>>>", bodydata);

        this.loaderService.showLoader = true;
        this.loader = true;
        this._apiService.updateRazorPaySubMerchantAccountDetails(bodydata);
      } else if (data.error) {
        const parsed = this.parseRazorpayState(data.state);
        const entityHashFromState = parsed.params["entityHash"] ?? null;

        if (entityHashFromState) {
          this.entityHashId = entityHashFromState;
          this.isEntityForeign = "0";
        }

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            entityHash: this.entityHashId,
            isEntityForeign: this.isEntityForeign,
          },
          queryParamsHandling: "", // Clears all other params
          replaceUrl: true,
        });

        this.loaderService.showLoader = true;
        this.loader = true;
        // this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        this._apiService.getDomesticEntityBankInfo(this.entityHashId);
      } else {
        console.log(data.entityHash);
        this.entityHashId = data.entityHash;
        this.isEntityForeign = data.isEntityForeign;

        if (this.isEntityForeign == "0") {
          this.loaderService.showLoader = true;
          this.loader = true;
          // this._apiService.getDomesticEntityBankInfo(this.entityHashId);
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        } else if (this.isEntityForeign == "1") {
          this.loaderService.showLoader = true;
          this.loader = true;
          this._apiService.getInternationalEntityBankInfo(this.entityHashId);
        }
      }
    });
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate() {
    this.router.navigate(["../"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  onToggleChange(event: any) {
    if (event.checked) {
      this.toShowCheck = 1;
      let data = {
        // hashId: this.onlinePaymentsData.length > 0 ? this.onlinePaymentsData[0].hashId : null,
        // created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // edited_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // business_hash_id: this.entityHashId,
        // online_payment_status: 1,

        entityHash: this.entityHashId,
        status: 1,
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      this.loaderService.showLoader = true;
      // this.loader = true
      this._apiService.enableOnlinePayments(data);
    } else if (!event.checked) {
      this.toShowCheck = 0;
      let data = {
        // hashId: this.onlinePaymentsData.length > 0 ? this.onlinePaymentsData[0].hashId : null,
        // created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // edited_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // business_hash_id: this.entityHashId,
        // online_payment_status: 0,

        entityHash: this.entityHashId,
        status: 0,
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      this.loaderService.showLoader = true;
      // this.loader = true
      this._apiService.enableOnlinePayments(data);
    }
  }
  onToggleChangeForInternational(event: any) {
    if (event.checked) {
      this.toShowCheckForInternational = 1;
      let data = {
        // hashId: this.onlinePaymentsData.length > 0 ? this.onlinePaymentsData[0].hashId : null,
        // created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // edited_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        // business_hash_id: this.entityHashId,
        // online_payment_status: 1,

        entityHash: this.entityHashId,
        online_payment_status: 1,
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      this.loaderService.showLoader = true;
      this._apiService.enableInternationalOnlinePayments(data);
    } else if (!event.checked) {
      this.toShowCheck = 0;
      let data = {
        entityHash: this.entityHashId,
        online_payment_status: 0,
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      this.loaderService.showLoader = true;
      this._apiService.enableInternationalOnlinePayments(data);
    }
  }

  openconfigureDiscount() {
    this.router.navigate(["configure-online-payment"], {
      relativeTo: this.route,
      queryParams: {
        isEdit:
          this.onlinePaymentsData[0].account_number &&
          this.onlinePaymentsData[0].account_number != "null"
            ? 1
            : 0,
      },
      queryParamsHandling: "merge",
    });
  }

  configureDiscount() {
    this._modelRef.open(AddEditOnlinePaymentComponent, {
      minWidth: "700px",
      data: {
        title: "Edit online payment",
        ref: this._modelRef,
        data: this.onlinePaymentsData[0],
        isEdit:
          this.onlinePaymentsData[0].account_number &&
          this.onlinePaymentsData[0].account_number != "null"
            ? 1
            : 0,
      },
    });
  }

  openexistingaccount() {
    if (this.bankDetailsData.length > 0) {
      let dialogref = this._modelRef.open(AddExistingAccountComponent, {
        width: "700px",
        data: {
          bankAccounts: this.bankDetailsData,
          entityHash: this.entityHashId,
        },
      });

      dialogref.afterClosed().subscribe((data) => {
        if (data) {
          this._apiService.getDomesticEntityBankInfo(this.entityHashId);
        }
      });
    } else {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Alert",
          message:
            "No Razorpay account integrated by you in this platform so far. Use the Get started button to add one.",
          okbtn: "Ok",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }
  openexistingaccountForInternational() {
    if (this.internationalBankDetailsData.length > 0) {
      let dialogref = this._modelRef.open(
        LinkInternationalOnlinePaymentDetailsComponent,
        {
          width: "900px",
          data: {
            bankAccounts: this.internationalBankDetailsData,
            entityHash: this.entityHashId,
          },
        }
      );

      dialogref.afterClosed().subscribe((data) => {
        if (data) {
          this._apiService.getInternationalEntityBankInfo(this.entityHashId);
        }
      });
    } else {
      // this.snackbar.open('No PayPal account added by you in the platform via the current account.', 'Ok', {
      //   duration: 3000
      // })
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Alert",
          message:
            "No PayPal account integrated by you in this platform so far. Use the Get started button to add one.",
          okbtn: "Ok",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }

  deleteAccount() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to delete this bank account information?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          razorpayId: this.onlinePaymentsData[0].razorpay_account_id,
          accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          entityHash: this.entityHashId,
        };

        this.loaderService.showLoader = true;
        this._apiService.deleteLinkedBankAccount(obj);
      }
    });
  }
  unLink() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to un-link this Razorpay account with this business?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          entity_hash: this.entityHashId,
          hash_id: this.onlinePaymentsData[0].hash_id,
        };
        console.log(obj);

        this.loaderService.showLoader = true;
        this._apiService.unlinkBankAccountFromBusiness(obj);
      }
    });
  }
  unLinkInternational() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to un-link this Paypal account with this business?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          entity_hash: this.entityHashId,
          hash_id: this.internationalOnlinePaymentsData[0].hash_id,
        };

        this.loaderService.showLoader = true;
        this._apiService.unlinkBankAccountFromInternationalBusiness(obj);
      }
    });
  }

  createPaypalPartnerAccount() {
    let bodydata = {
      entity_hash: this.entityHashId,
      account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      origin: 1,
    };

    this.loaderService.showLoader = true;
    this._apiService.createPaypalPartnerAccount(bodydata);
  }
  createRazorPaySubMerchantAccount() {
    let bodydata = {
      entity_hash: this.entityHashId,
      account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      origin: 1,
    };

    this.loaderService.showLoader = true;
    this._apiService.createRazorPaySubMerchantAccount(bodydata);
  }

  opensettings() {
    window.open("https://paypal.com/signin", "_blank");
  }
  openDomesticsettings() {
    window.open("https://dashboard.razorpay.com/", "_blank");
  }

  sync() {
    let data = {
      entityHash: this.entityHashId,
    };

    this.loaderService.showLoader = true;
    this._apiService.syncLatestPayPalData(data);
  }

  // Helper to parse the state string you receive
  private parseRazorpayState(rawState: string): {
    stateToken: string;
    params: Record<string, string>;
  } {
    const result: { stateToken: string; params: Record<string, string> } = {
      stateToken: "",
      params: {},
    };
    if (!rawState) return result;

    // split on first '|' — left is the state token, right is optional params part
    const [left, right] = rawState.split("|", 2);
    result.stateToken = left || "";

    if (right) {
      // right may contain one or more key=value pairs joined by & (handle both single pair and multiple)
      const pairs = right.split("&");
      for (const pair of pairs) {
        const [k, ...rest] = pair.split("=");
        if (!k) continue;
        const v = rest.length ? rest.join("=") : ""; // allow '=' in value (rare)
        try {
          result.params[k.trim()] = decodeURIComponent(v);
        } catch (e) {
          result.params[k.trim()] = v; // fallback if decode fails
        }
      }
    }

    return result;
  }
}
